import { Contract } from "ethers";
import abi from './abis/storefront'

class StorefrontContract extends Contract {
}

/** @returns {typeof import('./types/BSCStorefront').BSCStorefront} */
function cast(ContractClass) {
  return ContractClass
}

export default cast(StorefrontContract)

export function initializeStorefront(address, signerOrProvider) {
  const Klass = cast(StorefrontContract)
  return new Klass(address, abi, signerOrProvider)
}
